export interface GameOverWatcherOptions<F extends { body: { position: { y: number } } }> {
  fruits: () => F[];
  dangerLineY: number;
  graceMs: number;
  onGameOver: () => void;
}

export interface GameOverWatcher {
  tick(deltaMs: number): void;
  reset(): void;
  /** For tests + debug overlay. */
  elapsedAboveMs(): number;
  /** True if any fruit is currently above the line. */
  isAboveLine(): boolean;
}

export function createGameOverWatcher<F extends { body: { position: { y: number } } }>(
  opts: GameOverWatcherOptions<F>,
): GameOverWatcher {
  let elapsedAboveMs = 0;
  let fired = false;

  function isAnyAbove(): boolean {
    for (const fruit of opts.fruits()) {
      if (fruit.body.position.y < opts.dangerLineY) return true;
    }
    return false;
  }

  return {
    tick(deltaMs: number) {
      if (fired) return;
      if (isAnyAbove()) {
        elapsedAboveMs += deltaMs;
        if (elapsedAboveMs >= opts.graceMs) {
          fired = true;
          opts.onGameOver();
        }
      } else {
        elapsedAboveMs = 0;
      }
    },
    reset() {
      elapsedAboveMs = 0;
      fired = false;
    },
    elapsedAboveMs: () => elapsedAboveMs,
    isAboveLine: isAnyAbove,
  };
}
